module.exports = __webpack_public_path__ + "img/20220328_142314.037666f4.jpg";